import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDemolitionFilter } from 'shared/selectors/advancedFilters/demolition';

export const DemolitionContainer: FC = () => {
  const { label, value, options, visible } = useSelector(selectDemolitionFilter);

  const onChange = useFilterChangeCallback();

  const handleDemolitionChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setDemolition', arguments: [newValue] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter options={options} value={value} onFilterChange={handleDemolitionChange} />
    </AdvancedFilterRow>
  );
};
